import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaiairporttovadodaracab() {



  const cardData = {
    keyword: " Mumbai Airport to Vadodara Cab",


"headingDescription": "Royal Route Cab offers reliable Mumbai Airport to Vadodara cab service, providing safe, comfortable, and affordable intercity and airport transfer travel for families, corporate passengers, students, and business travelers. Vadodara is a major city in Gujarat located approximately 390–420 km from Mumbai Airport, connected via smooth national highways that ensure a comfortable long-distance road journey. Our professional drivers provide punctual airport pickups, hassle-free luggage assistance, and a stress-free travel experience with well-maintained vehicles. We offer flexible options including one-way drops, round trips, and customized travel schedules based on your flight timing. Our fleet includes economy sedans, premium sedans, SUVs, Innova, Ertiga, Innova Crysta, and Tempo Travellers suitable for all group sizes. With transparent pricing, 24/7 availability, and easy booking, Royal Route Cab is your trusted choice for Mumbai Airport to Vadodara cab service.",

"topPlaces": [
  {
    "title": "Laxmi Vilas Palace",
    "description": "Laxmi Vilas Palace is one of the grandest royal residences in India, four times the size of Buckingham Palace. Built by the Gaekwad dynasty, it showcases Indo-Saracenic architecture, luxurious interiors, and vast gardens. It is the most iconic attraction in Vadodara and a must-visit for travelers arriving from Mumbai Airport by cab."
  },
  {
    "title": "Sayaji Baug (Kamati Baug)",
    "description": "Sayaji Baug is a large public garden and one of the most popular recreational spaces in Vadodara. It features a zoo, planetarium, museum, and toy train, making it a perfect family destination after a long journey from Mumbai Airport."
  },
  {
    "title": "EME Temple",
    "description": "The EME Temple is a unique modern temple dedicated to Lord Shiva, maintained by the Indian Army. Its futuristic geodesic structure and peaceful surroundings make it a distinctive spiritual and architectural attraction in Vadodara."
  },
  {
    "title": "Kirti Mandir",
    "description": "Kirti Mandir is a cenotaph built in memory of the Gaekwad royal family. It features beautiful murals and carvings depicting Hindu mythology and royal history, making it a key cultural landmark in Vadodara."
  },
  {
    "title": "Champaner-Pavagadh Archaeological Park",
    "description": "A UNESCO World Heritage Site located near Vadodara, Champaner-Pavagadh features ancient forts, mosques, temples, and historical ruins. It is a major attraction for history lovers and spiritual travelers coming from Mumbai Airport by cab."
  },
  {
    "title": "Sursagar Lake",
    "description": "Sursagar Lake is a scenic waterbody in the heart of Vadodara, known for its large statue of Lord Shiva and peaceful evening views. It is a popular relaxation spot for locals and visitors after city sightseeing."
  },
  {
    "title": "Vadodara Museum and Picture Gallery",
    "description": "This museum showcases art, sculptures, manuscripts, and artifacts collected by the Gaekwad rulers. It provides deep insights into the cultural and historical heritage of Vadodara."
  },
  {
    "title": "Ajwa Water Park & Garden",
    "description": "Ajwa Water Park and Garden is a family-friendly recreational destination featuring amusement rides, gardens, and water attractions. It is a popular weekend outing spot for travelers from Mumbai Airport."
  },
  {
    "title": "Makarpura Palace",
    "description": "Makarpura Palace is a historical royal palace that reflects European architectural influence. Although partly in use by the Indian Air Force, it remains an important heritage site in Vadodara."
  },
  {
    "title": "Nyaya Mandir",
    "description": "Nyaya Mandir is a historic courthouse building in Vadodara known for its Indo-Gothic architecture and civic importance. It is located in the old city area and is a key landmark for heritage exploration."
  }
],






services: [
  {
    name: "Mumbai Airport to Vadodara Cab",
    description: "Mumbai airport to Vadodara cab service offers a comfortable and direct long-distance journey from the airport to Vadodara. Ideal for business travelers, families, and tourists, this service ensures smooth highway travel with experienced drivers. Well-maintained vehicles enhance comfort. It guarantees a safe and hassle-free transfer."
  },
  {
    name: "Mumbai Airport to Vadodara Taxi",
    description: "Mumbai airport to Vadodara taxi provides private and convenient intercity travel with door-to-door pickup from the airport terminal. This service is ideal for long-distance travel with flexible scheduling. It ensures a smooth and reliable journey."
  },
  {
    name: "Mumbai to Vadodara Cab from Airport",
    description: "Mumbai to Vadodara cab from airport offers seamless pickup directly from arrival terminals for immediate travel. This service is perfect for travelers arriving by flight. Professional drivers ensure timely service. It ensures a stress-free experience."
  },
  {
    name: "Mumbai Airport to Vadodara Taxi Service",
    description: "Mumbai airport to Vadodara taxi service ensures dependable long-distance travel with comfortable seating and professional chauffeurs. This service is ideal for business trips and family travel. It guarantees a smooth and pleasant journey."
  },
  {
    name: "Cab from Mumbai Airport to Vadodara",
    description: "Cab from Mumbai airport to Vadodara offers a convenient way to travel directly from the airport to your destination. This service is ideal for those who prefer road travel after flights. Experienced drivers ensure safe journeys. It ensures a relaxed trip."
  },
  {
    name: "Taxi from Mumbai Airport to Vadodara",
    description: "Taxi from Mumbai airport to Vadodara provides reliable long-distance travel for individuals and groups. This service ensures smooth highway journeys with professional drivers. Comfortable seating enhances the experience. It guarantees a dependable ride."
  },
  {
    name: "Mumbai Airport to Vadodara Cab Booking",
    description: "Mumbai airport to Vadodara cab booking allows customers to reserve their ride easily in advance. Travelers can choose vehicle type, pickup terminal, and timing. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Mumbai Airport to Vadodara Taxi Booking Online",
    description: "Mumbai airport to Vadodara taxi booking online provides a quick and convenient way to plan your journey. Customers can compare vehicles and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Mumbai Airport to Vadodara Cab Price",
    description: "Mumbai airport to Vadodara cab price varies based on vehicle type, distance, and trip duration. Transparent pricing ensures no hidden charges. Customers can choose from budget and premium options. It helps in planning travel expenses efficiently."
  },
  {
    name: "Mumbai Airport to Vadodara Taxi Fare",
    description: "Mumbai airport to Vadodara taxi fare is designed to be competitive for long-distance travel. Fare depends on route and vehicle selection. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Mumbai Airport to Vadodara One Way Cab",
    description: "Mumbai airport to Vadodara one way cab offers cost-effective travel without return charges. This service is ideal for single-side journeys. Flexible pickup options enhance convenience. It ensures smooth and economical travel."
  },
  {
    name: "Mumbai Airport to Vadodara Round Trip Taxi",
    description: "Mumbai airport to Vadodara round trip taxi provides complete travel solutions including return journeys. This service is ideal for business trips and extended stays. Flexible schedules enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Mumbai Airport to Vadodara Innova Cab",
    description: "Mumbai airport to Vadodara Innova cab is perfect for families and groups seeking spacious and comfortable travel. Premium seating and smooth performance enhance long journeys. It ensures a comfortable intercity experience."
  },
  {
    name: "Mumbai Airport to Vadodara Ertiga Cab",
    description: "Mumbai airport to Vadodara Ertiga cab offers affordable and spacious travel for small groups and families. Comfortable seating and good mileage make it ideal for long-distance journeys. It ensures a pleasant trip."
  },
  {
    name: "Mumbai Airport to Vadodara Sedan Cab",
    description: "Mumbai airport to Vadodara sedan cab is ideal for individuals and small families seeking economical travel. Sedans offer smooth rides and comfort for long journeys. Professional drivers ensure safety. It ensures a relaxed journey."
  },
  {
    name: "Mumbai Airport to Vadodara SUV Taxi",
    description: "Mumbai airport to Vadodara SUV taxi provides spacious and comfortable travel for groups. SUVs offer better performance and extra luggage space. Suitable for long-distance journeys. It ensures a comfortable travel experience."
  }
],

tableData: [
  ["Mumbai Airport to Vadodara Cab", "Mumbai Airport to Vadodara Taxi"],
  ["Mumbai to Vadodara Cab from Airport", "Mumbai Airport to Vadodara Taxi Service"],
  ["Cab from Mumbai Airport to Vadodara", "Taxi from Mumbai Airport to Vadodara"],
  ["Mumbai Airport to Vadodara Cab Booking", "Mumbai Airport to Vadodara Taxi Booking Online"],
  ["Mumbai Airport to Vadodara Cab Price", "Mumbai Airport to Vadodara Taxi Fare"],
  ["Mumbai Airport to Vadodara One Way Cab", "Mumbai Airport to Vadodara Round Trip Taxi"],
  ["Mumbai Airport to Vadodara Innova Cab", "Mumbai Airport to Vadodara Ertiga Cab"],
  ["Mumbai Airport to Vadodara Sedan Cab", "Mumbai Airport to Vadodara SUV Taxi"]
],


whychoose: [
  {
    WhyChooseheading: "Direct Airport to Vadodara Cab Service",
    WhyChoosedescription: "Royal Route Cabs offers seamless Mumbai Airport to Vadodara cab service with direct pickup from Terminal 1 and Terminal 2 for a hassle-free journey."
  },
  {
    WhyChooseheading: "Experienced Interstate Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in interstate travel routes, ensuring safe driving and smooth navigation to Vadodara."
  },
  {
    WhyChooseheading: "On-Time Airport Pickup with Flight Tracking",
    WhyChoosedescription: "We monitor flight timings to ensure timely pickup even if your flight is delayed, providing a stress-free airport transfer."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls, driver allowance, and all travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way airport drop to Vadodara or round-trip bookings based on your travel needs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai Airport to Vadodara cab service operates 24/7 for late-night arrivals and early morning departures."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for group travel."
  },
  {
    WhyChooseheading: "Trusted Long-Distance Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai Airport to Vadodara cab bookings due to reliable service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai Airport to Vadodara cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai Airport to Vadodara for one-way and round trips." },
  { question: "What is the distance between Mumbai Airport and Vadodara?", answer: "The distance is approximately 400 to 430 km and takes around 7 to 9 hours depending on route and traffic." },
  { question: "Which airport terminals are covered?", answer: "We provide pickup from both Terminal 1 and Terminal 2 of Mumbai Airport." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Do you provide interstate travel permits?", answer: "Yes, all required permits are arranged for smooth interstate travel." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for long-distance travel." },
  { question: "Do you provide doorstep drop?", answer: "Yes, we provide drop to home, hotel, or office in Vadodara." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ankit Shah",
    feedback: "The Mumbai Airport to Vadodara cab service with Royal Route Cabs was very smooth and punctual. The driver was waiting on time and ensured a comfortable long-distance journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Patel",
    feedback: "Excellent airport transfer experience from Mumbai to Vadodara. The cab was clean, ride was comfortable, and the entire service felt very reliable.",
    rating: 5
  }
];










  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport to Vadodara Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-airport-to-vadodara-cab.jpg", // replace if needed
  "description": "Book Mumbai Airport to Vadodara cab service with Royal Route Cabs for safe, reliable, and comfortable intercity travel. Available for one-way and round-trip journeys with sedan, SUV, Innova, and Ertiga vehicles. 24x7 airport pickup and drop taxi service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9999", // approx starting fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-airport-to-vadodara-cab"
  }
};







  return (
    <div>
<Helmet>
  <title>Mumbai Airport to Vadodara Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai Airport to Vadodara cab with Royal Route Cabs. Safe and affordable airport pickup and drop taxi service with sedan, SUV, Innova & Ertiga cars. 24x7 reliable travel."
  />

  <meta
    name="keywords"
    content="mumbai airport to vadodara cab, mumbai airport to vadodara taxi, mumbai to vadodara cab from airport, mumbai airport to vadodara taxi service, cab from mumbai airport to vadodara, taxi from mumbai airport to vadodara, mumbai airport to vadodara cab booking, mumbai airport to vadodara taxi booking online, mumbai airport to vadodara cab price, mumbai airport to vadodara taxi fare, mumbai airport to vadodara one way cab, mumbai airport to vadodara round trip taxi, mumbai airport to vadodara innova cab, mumbai airport to vadodara ertiga cab, mumbai airport to vadodara sedan cab, mumbai airport to vadodara suv taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/59.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairporttovadodaracab;